import api from "@/api/gql.js"

import { query, mutation } from "./queries"

export default {
	async getPlans(variables) {
		const res = await api({
			query: query.getPlans,
			variables
		})

		return res
	},

	async getPlanDetail(variables, locale) {
		const res = await api({
			locale,
			query: query.getPlanDetail,
			variables
		})

		return res
	},

	async createPlan(variables) {
		const res = await api({
			query: mutation.createPlan,
			variables
		})

		return res
	},

	async deletePlan(variables) {
		const res = await api({
			query: mutation.deletePlan,
			variables
		})

		return res
	},

	async createPricingLogic(variables) {
		const res = await api({
			query: mutation.createPlanPriceLogic,
			variables
		})

		return res
	},

	async updatePricingLogic(variables) {
		const res = await api({
			query: mutation.updatePlanPriceLogic,
			variables
		})

		return res
	},

	async deletePricingLogic(variables) {
		const res = await api({
			query: mutation.deletePlanPriceLogic,
			variables
		})

		return res
	},

	async localizePlan(variables) {
		const res = await api({
			query: mutation.localizePlan,
			variables
		})

		return res
	},

	async deleteAllL10n(variables) {
		const res = await api({
			query: mutation.deleteAllL10n,
			variables
		})

		return res
	},

	async addTagToPlan(variables) {
		const res = await api({ query: mutation.addTagToPlan, variables })
		return res
	},

	async removeTagFromPlan(variables) {
		const res = await api({ query: mutation.removeTagFromPlan, variables })
		return res
	}
}
